import {
  FETCH_NOW_NEXT,
  FETCH_NOW_NEXT_IS_LOADING,
  FETCH_NOW_NEXT_HAS_ERRORED,
} from './types';
import { globalFetch } from './globalActions';

///////////
// Now Next //
///////////

export function fetchNowNext() {
  return globalFetch({
    urlPath: `now_and_next_v2`,
    reducerIsLoading: FETCH_NOW_NEXT_IS_LOADING,
    reducerError: FETCH_NOW_NEXT_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch({ type: FETCH_NOW_NEXT, payload: itemObj?.now_and_next ?? {} });
    },
  });
}
